<template>
  <div >
    <div class="banner">
      <span>{{$t('contact.banner')}}</span>
    </div>
    <div class="section-wrap ">
      <!-- <div class="rela">
        <div class="mobile tc tab-nav-text" @click="showTabnav=!showTabnav">{{tab==1?'泉州市六韬电子商务有限公司':''}}{{tab==2?'福建泉州迈达兴鞋业有限公司':''}}<img src="@/assets/images/public/icon-arrow2.png"></div>
        <div class="tab-nav clearfix c-333 pc">
          <div :class="tab==1?'active':''" @click="tab=1">泉州市六韬电子商务有限公司</div>
          <div :class="tab==2?'active':''"  @click="tab=2;">福建泉州迈达兴鞋业有限公司</div>
        </div>
        <div class="tab-nav clearfix c-333 mobile" v-show="showTabnav">
          <div :class="tab==1?'active':''" @click="tab=1;showTabnav=false;">泉州市六韬电子商务有限公司</div>
          <div :class="tab==2?'active':''"  @click="tab=2;showTabnav=false;">福建泉州迈达兴鞋业有限公司</div>
        </div>
      </div> -->

      <div class="tab-content ">
        <div :class="'tab1 '+(tab==1||!shop[0].loadComp?'':'hide')">
        <div class="rela">

          <!--<img src="@/assets/images/contact/map1.jpg" class="block w100 map-img"/>-->
          <baidu-map :center="shop[0].center" :zoom="shop[0].zoom" @ready="handler1" class="map-img2" @click="getClickInfo" :scroll-wheel-zoom='true' >
          </baidu-map>
          <div class="map-info b-fff abso c-333">
              <p class="pc">{{ $t('contact.shop.s1') }}</p>
              <p class="pc company-name">{{ $t('contact.shop.s2') }}</p>
            <ul>
              <li>
                <img src="@/assets/images/public/icon-contact_03.png">
                <div>
                  <p>{{ $t('contact.shop.s3') }}</p>
                  <p class="c-666">{{ $t('contact.shop.s3_1') }}</p>
                </div>

              </li>
              <li>
                <img src="@/assets/images/public/icon-contact_07.png">
                <div>   <p>{{ $t('contact.shop.s4') }}</p>
                  <p class="c-666">{{ $t('contact.shop.s4_1') }}</p>
                </div>

              </li>
              <li>
                <img src="@/assets/images/public/icon-contact_08.png">
                <div>
                  <p>{{ $t('contact.shop.s5') }}</p>
                  <p class="c-666">{{ $t('contact.shop.s5_1') }}</p>
                </div>

              </li>
            </ul>
          </div>
        </div>
        </div>
        <!-- <div :class="tab==2||!shop[1].loadComp?'':'hide'">
          <div class="rela">
            <baidu-map :center="shop[1].center" :zoom="shop[1].zoom" @ready="handler2" class="map-img2" @click="getClickInfo" :scroll-wheel-zoom='true' >
            </baidu-map>
            <div class="map-info b-fff abso c-333">
              <p class="pc">研发中心</p>
              <ul>
                <li>
                  <img src="@/assets/images/public/icon-contact_03.png">
                  <div>
                    <p>电话</p>
                    <p class="c-666">0086-0595-28888337</p>
                  </div>

                </li>
                <li>
                  <img src="@/assets/images/public/icon-contact_06.png">
                  <div>   <p>邮箱</p>
                    <p class="c-666">mryan@disrun.com</p>
                  </div>

                </li>
                <li>
                  <img src="@/assets/images/public/icon-contact_08.png">
                  <div>
                    <p>地址</p>
                    <p class="c-666">福建 泉州市 台商投资区 东园镇下垵村下垵232号</p>
                  </div>

                </li>
              </ul>
            </div>
          </div>
        </div> -->
        <div class="form">
            <p class="c-333 tc">{{$t('contact.banner')}}</p>
            <p class="c-666 tc pc">{{$t('contact.ps')}}
            </p>
             <p class="c-666 tc mobile" v-html="$t('contact.ps1')"> </p>
            <div class="clearfix">
              <div class="input-group">
                <label><span style="color:#f5222d">*</span>{{$t('contact.q1')}}</label>
                <div class="input"><img src="@/assets/images/contact/icon-form-m_03.svg"/><input type="text" :placeholder="$t('contact.p1')" v-model.trim="form.name"/>
                </div>
              </div>
              <div class="input-group">
                <label><span style="color:#f5222d">*</span>{{$t('contact.q2')}}</label>
                <div class="input"><img src="@/assets/images/contact/icon-form-m_05.svg"/><input type="text" :placeholder="$t('contact.p2')" v-model.trim="form.contactNumber"/>
                </div>
              </div>
              <div class="input-group">
                <label>{{$t('contact.q3')}}</label>
                <div class="input"><img src="@/assets/images/contact/icon-form-m_07.svg"/><input type="text" :placeholder="$t('contact.p3')" v-model.trim="form.contactUnit"/>
                </div>
              </div>
              <div class="input-group textarea-group">
                <label><span style="color:#f5222d">*</span>{{$t('contact.q4')}}</label>
                <div class="input"><img src="@/assets/images/contact/icon-form-m_12.svg"/><textarea type="text" :placeholder="$t('contact.p4')" v-model.trim="form.messageContent"></textarea>
                </div>
              </div>
            </div>
          <div class="btn-submit" @click="submit">{{$t('contact.submit')}}</div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

  import { addMessage } from '@api/index'
  import { monitorPush } from '@/main'

  export default {
    name: 'contact',
    data () {
      return {
          loading:false,
          shop:[{name:this.$t('contact.m1'),loadComp:false,
              center: {lng: 118.660327, lat: 24.8712},
              zoom: 15
          },
          // {name:"研发中心",loadComp:false,
          //     center: {lng: 118.76216, lat: 24.87212},
          //     zoom: 15
          // }
        ],
          tab:1,
          loadComp:false,
          showTabnav:false,
          curImg:'',
          form:{contactNumber:'',contactUnit:'',messageContent:'',name:''}
      }
    },
    created () {
      this.getList()

    },
    methods: {
      getList() {

      },
        submit(){

          if(this.form.contactNumber==''||this.form.name==''||this.form.messageContent==''){
              this.$message.error(this.$t('contact.t1'))
              return false;
          }
            var myreg = /^((\s)?(0)?(1)\d{10}(\s)?)+$/;
         if (!myreg.test(this.form.contactNumber)) {
             this.$message.error(this.$t('contact.t2'))
             return false;
            }
            this.$loading.show()
            monitorPush({category: 'mobile', action: 'click', page: this.$route.fullPath, label: '留言提交'});
            addMessage(this.form).then(res => {
                this.$loading.hide()
                if(res.code==0){
                    this.$message.success(this.$t('contact.t3'))
                    this.form={contactNumber:'',contactUnit:'',messageContent:'',name:''}
                }else{
                    this.$message.error(res.msg)
                }

                // console.log(res)
            })
        },
        tabEvent(){

        },
        handler1({BMap, map}){
          this.handler({BMap, map},1)
        },
        handler2({BMap, map}){
            this.handler({BMap, map},2)
        },
        handler3({BMap, map}){
            this.handler({BMap, map},3)
        },
        handler ({BMap, map},type) {
          // console.log(type)
          let _this=this
            var point = new BMap.Point(_this.shop[type-1].center.lng,_this.shop[type-1].center.lat)
            map.centerAndZoom(point, _this.shop[type-1].zoom)
            map.enableScrollWheelZoom()
            var marker = new BMap.Marker(point) // 创建标注
            map.addOverlay(marker) // 将标注添加到地图中
            var circle = new BMap.Circle(point, 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
            map.addOverlay(circle)
            var opts = {
                position : point,    // 指定文本标注所在的地理位置
                offset   : new BMap.Size(-9,-35)    //设置文本偏移量
            }
            var label = new BMap.Label(_this.shop[type-1].name, opts);  // 创建文本标注对象
            label.setStyle({
                background:"#005bac",
                color : '#fff',
                border:0,
                fontSize : '.2rem',
                height : '.7rem',
                padding:"0 1em",
                lineHeight : '.7rem',
                marginTop:"-.8rem",
                marginLeft:'-'+(_this.shop[type-1].name.length/2+0.5)+'em',
                fontFamily: '微软雅黑'
            });
            map.addOverlay(label);
            setTimeout(()=>{
                _this.shop[type-1].loadComp=true
            },100)

        },
        getClickInfo (e) {
            // console.log(e.point.lng)
            // console.log(e.point.lat)
            // this.center.lng = e.point.lng
            // this.center.lat = e.point.lat
        }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .section-wrap{padding-top:.48rem}
  .realize-more
    user-select none;cursor pointer
  h2,h3,h4,h5,h6,p{
    margin: 0
  }
    input,textarea{   background :rgba(255,255,255,0);border:0;font-size:.16rem;color:#333;
    &::placeholder{color:#999;}
    }

  .banner{height:280px;background :url("~@/assets/images/contact/banner.jpg") no-repeat center/auto 100%;}
  .tab-nav{margin-bottom:0;}
  .tab-nav>div{width:100%;}
    .tab-content{margin-bottom: 1.45rem;}

.map-info{right:.5rem;padding:.35rem 0.24rem .24rem;top:.32rem;width:3rem;
 &>p{font-size:.2rem;margin-bottom:.08rem;
  &.company-name{font-size:.16rem}
}
  li{border-bottom:1px solid #e5e5e5;padding: 0.12rem 0 0.13rem;
  &:last-child{border:0;}
  img{width:.28rem;height:.28rem;margin-left: -.035rem;margin-bottom: .08rem;}
    p{ font-size :.16rem}
  .c-666{font-size:.14rem;line-height :.24rem;}
  }
}
.form{background :#fff;padding:0.4rem 0.5rem .85rem;
  &>.c-333{font-size:.3rem;    margin-bottom: .15rem;}
  &>.c-666{font-size:.16rem;line-height 2em;    margin-bottom: .5rem;
  a{color:$standardColor;text-decoration: underline}}
}
.input-group{
  font-size:.16rem;width:31.4%;float :left;margin-left :2.9%;margin-bottom:.35rem;
  &:first-child{margin-left:0;}
  label{color:#333;margin-bottom:.17rem;display :block;}
  .input{background:#f8f8f8;border:1px solid #e5e5e5;border-radius:.03rem;height:.58rem;
  img{width:.22rem;height:.22rem;display :inline-block;margin:0 .1rem 0 .16rem;vertical-align :middle;}
input{height:100%;width:2.7rem;    display: inline-block;
  vertical-align: middle;}
}
}
.textarea-group{margin-left:0;width:100%;
  .input {padding:.28rem 0;height:2.06rem;
    img{vertical-align: top;
  }
  textarea{width: 93%;resize :none;
  height: 1.6rem;
  margin-top: -.03rem;}

  }
}
.btn-submit{font-size:.16rem;color:#fff;background :$standardColor;text-align :center;width:1.4rem;line-height:.48rem;border-radius :2px;cursor pointer;}
  .map-img{width:100%;height:auto;}
  .map-img2{height:5.46rem;width:100%;}
    .tab1{background:#fff;}
  @media screen and (max-width: 768px){
    .section-wrap{padding:0;padding-top:.24rem}
    input,textarea{font-size:.24rem;}
    .banner{height:3.7rem;background url("~@/assets/images/contact/m-banner.jpg") no-repeat center/auto 100%;}
    .tab-nav-text{line-height:1.05rem;font-size:.26rem;background :#fff;rela();z-index :1;box-shadow :0 0.02rem 0.1rem 0 rgba(0,0,0,0.04);
    img{margin-left:.3rem;width:.17rem;}}
    .tab-nav{abso();width:100%;z-index: 1;padding: 0;
    &>div{width:100%;line-height:1.05rem;border:0;border-top:1px solid #fafafa;
    &:first-child{border:0;}
    }
    }

    .tab-content{background:#f8f8f8;margin-bottom: .25rem;overflow-x hidden;}
      .tab1{background:#f8f8f8;}
  .map-img{height:5.45rem;width:auto;}
    .map-img2{height:5.45rem;}
    .map-info{
      rela();top:0;right :0;width:100%;padding: 0 .32rem;margin-bottom: 0.24rem;
      li{padding:.2rem 0;
        img{    width: 0.38rem;
          height: 0.38rem;
          margin-left: -0.07rem;
          display: inline-block;
          vertical-align: top;
          margin-top: 0.02rem;
          margin-right: .15rem;}
        div{display :inline-block;vertical-align :top;width:6rem;}
        p{font-size:.26rem;}
        .c-666{font-size:.24rem;line-height: .4rem;}
      }

    }
    .form{padding:0.4rem .3rem .75rem;
    &>.c-333{font-size:.32rem; }
      &>.c-666{font-size:.24rem;line-height .4rem; }
    }
    .input-group{width:100%;margin-left:0;font-size :.24rem;margin-bottom :.3rem;
.input{height:.9rem;
img{width:.38rem;height:.38rem;margin:0 .2rem 0 .18rem;}
  input{width:5.8rem;}
}
    }
    .textarea-group{
      .input{height:3.25rem;
        textarea{width:5.8rem;height:2.75rem;}}

    }
    .btn-submit{font-size:.24rem;width:1.9rem;line-height :.64rem;}
  }
</style>
<style >
  body{background :#f8f8f8}
  .BMapLabel:after{content:'';position: absolute;border:.12rem solid rgba(0,91,172,.0);border-top-color: rgba(0,91,172,1);top:100%;left:50%;margin-left:-.08rem; }
  </style>
